var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-skeleton',{staticClass:"footer-wrapper",attrs:{"animation":"wave"}})
}
var staticRenderFns = []

export { render, staticRenderFns }